'use strict'

module.exports = function () {
  throw new Error('WebSocket Servers can not be created in the browser!')
}
